import { Store } from 'flux/utils';
import EditorDispatcher from '../dispatchers/EditorDispatcher';

class EditorStore extends Store<{}> {
  private editors: Editor[] = [];
  private volumes: number[] = [];

  getEditors(): Editor[] {
    return this.editors;
  }

  getVolumes(): number[] {
    return this.volumes;
  }

  __onDispatch(payload: DispatchPayload) {
    if (payload.source === 'UPDATE_EDITORS') {
      this.editors = payload.output;
      this.computeVolumesFromEditors();
      this.__emitChange();
    }
  }

  private computeVolumesFromEditors() {
    const newVolumes: number[] = [];
    this.editors.forEach((e: Editor) => {
      if (newVolumes.indexOf(e.volume) === -1) {
        newVolumes.push(e.volume);
      }
    });
    newVolumes.sort((a: number, b: number) => a - b);
    this.volumes = newVolumes;
  }
}

const instance = new EditorStore(EditorDispatcher);
export default instance;



// WEBPACK FOOTER //
// ./src/stores/EditorStore.ts